import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children, adminOnly = false, ioyouOnly = false }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const rawAccountType = user?.cmAccountType;
  const isIoyou = rawAccountType === 'ioyou';
  const isFullAccess = rawAccountType === 'admin' || isIoyou;

  if (ioyouOnly && !isIoyou) {
    return <Navigate to={isFullAccess ? '/dashboard' : '/coupons'} replace />;
  }

  if (adminOnly && !isFullAccess) {
    return <Navigate to="/coupons" replace />;
  }

  return children;
};

export default PrivateRoute;
